import { Component, Input, OnInit } from '@angular/core';
import { environment } from './../../../../environments/environment';

@Component({
	selector: 'app-cig-the-universal-process-develop',
	templateUrl: './cig-the-universal-process-develop.component.html',
	styleUrls: ['./cig-the-universal-process-develop.component.scss']
})
export class CigTheUniversalProcessDevelopComponent implements OnInit {

	@Input() slides;
	@Input() foursightassets;
	@Input() author;
	public env;

	constructor() { }

	ngOnInit() {
		this.env=environment;
	}

}
